import React from 'react';
import { Controller } from 'react-hook-form';
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';

export default function FormSelectField({
  name,
  control,
  label,
  options,
  onChange,
  readOnly = false,
  disabled = false,
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormControl size="small" fullWidth error={Boolean(fieldState.error)}>
          <InputLabel>{label}</InputLabel>
          <Select
            {...field}
            label={label}
            readOnly={readOnly}
            disabled={disabled}
            value={field.value ?? ''}
            onChange={(e) => {
              field.onChange(e); // always update RHF first
              onChange?.(e); // then call external callback if provided
            }}
          >
            {' '}
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
      )}
    />
  );
}
